import React from 'react';

import App from 'src/App';

import { createRoot } from 'react-dom/client';

import '@splunk-iteng/header-footer/styles.css';

const rootElement = document.getElementById('root');

if (rootElement) {
  createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
